var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.title,
        primaryAction: _vm.primaryAction,
        secondaryActions: _vm.secondaryActions
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
        _vm._v("\n        " + _vm._s(_vm.message) + "\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }